<template>
  <div class="control">
    <el-container>
      <el-menu :default-active="defaultActive" :router="true" class="el-menu-vertical-demo" background-color="#2d2d2d"
        text-color="#ffffff" active-text-color="#EC8E00" :collapse="isCollapse">
        <el-menu-item @click="isCollapse = !isCollapse">
          <i class="el-icon-s-help"></i>
          <span slot="title">{{
            $store.state.shortName == null
              ? "上海益埃毕"
              : $store.state.shortName
          }}</span>
        </el-menu-item>
        <el-menu-item class="textEllipsis" :index="'/' + item.path" v-for="(item, index) in menuData" :key="index"
          :route="item.path">
          <i :class="item.icon" v-if="!item.icon.includes('ktr-')"></i>
          <i class="icon iconfont" :class="item.icon" v-else></i>
          <span slot="title" :title="item.authName">{{ item.authName
          }}</span>
        </el-menu-item>
      </el-menu>
      <el-main>
        <router-view v-if="viewShow" ref="view"></router-view>
      </el-main>
    </el-container>
  </div>
</template>

<script>
export default {
  name: "control",
  data() {
    return {
      isEn: this.$i18n.locale == 'en',
      defaultActive: null,
      viewShow: true,
      paths: "",
      isCollapse: true,
      isTransition: true,
      menuData: [
        {
          id: 1,
          authName: this.$t("控制台侧边栏.企业管理"),
          path: "enterpriseManagement",
          icon: "ktr-qyguanli",
        },
        {
          id: 2,
          authName: this.$t("控制台侧边栏.项目管理"),
          path: "enterpriseProject",
          icon: "el-icon-s-order",
        },
        {
          id: 3,
          authName: this.$t("控制台侧边栏.模型管理"),
          path: "enterpriseModelManagement",
          icon: "ktr-moxinggl",
        },
        {
          id: 4,
          authName: this.$t("控制台侧边栏.人员管理"),
          path: "enterprisePersonnel",
          icon: "ktr-chengyuanguanli",
        },
        {
          id: 5,
          authName: this.$t("控制台侧边栏.操作管理"),
          path: "operationInfo",
          icon: "el-icon-s-platform",
        },
      ],
    };
  },
  computed: {
    routerPath() {
      return this.$route.name;
    },
  },
  watch: {
    routerPath() {
      this.paths = this.$route.name;
    },
    $route: {
      handler: function (newRoute, oldRoute) {
        this.defaultActive = newRoute.path
      },
      // 深度观察监听
      deep: true
    },
  },
  methods: {
    // 执行刷新
    refreshData() {
      this.viewShow = false;
      this.$nextTick(() => {
        this.viewShow = true;
      });
    },
  },
  created() {
    this.defaultActive = this.$route.path
    this.paths = this.$route.fullPath.substr(1);
  },
  mounted() { },
};
</script>
<style lang="less" scoped>
.el-menu-item i {
  color: #fff;
}

.is-active {
  i {
    color: #EC8E00;
  }
}

.el-menu-vertical-demo {
  height: 100%;
}

.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 200px;
  height: 100%;
}

.control {
  width: 100%;
  height: 100%;
  overflow: hidden;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
}

.el-container {
  width: 100%;
  height: 100%;
}

.view {
  background-color: #f4f4f5;
  width: 100%;
  height: 100%;
  padding: 20px;
}

.font-sz {
  font-size: 18px;
  font-weight: 600;
}
</style>
